import { BrowserRouter as Router } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './app/contexts/AuthProvider';
import LandingRoutes from './routes/LandingRoutes';
import AppRoutes from './routes/AppRoutes';
import './index.css';

function App() {
  // Check if we're on the app subdomain
  const isAppSubdomain = window.location.hostname.startsWith('app.');
  
  return (
    <AuthProvider>
      <Router>
        {isAppSubdomain ? (
          // App subdomain - show app routes
          <AppRoutes />
        ) : (
          // Main domain - show landing routes
          <Routes>
            <Route path="/*" element={<LandingRoutes />} />
          </Routes>
        )}
      </Router>
    </AuthProvider>
  );
}

export default App;